import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TriviaComponent } from './trivia/trivia.component';
import { PageLoginComponent } from './page-login/page-login.component';
import { PageTriviaHostComponent } from './page-trivia-host/page-trivia-host.component';
import { PageHomeComponent } from './page-home/page-home.component';
import { TelestrationsComponent } from './telestrations/telestrations.component';
import { PageTelestrationsHostComponent } from './page-telestrations-host/page-telestrations-host.component';
import { TriviaHostLoginResolver } from './shared/resolvers/trivia-host-login-resolver';
import { TelestrationsHostLoginResolver } from './shared/resolvers/telestrations-host-login-resolver';
import { LiarsDiceComponent } from './liars-dice/liars-dice.component';
import { PageLiarsDiceHostComponent } from './page-liars-dice-host/page-liars-dice-host.component';
import { LiarsDiceHostLoginResolver } from './shared/resolvers/liars-dice-host-login-resolver';
import { PageScattergoriesHostComponent } from './page-scattergories-host/page-scattergories-host.component';
import { ScattergoriesHostLoginResolver } from './shared/resolvers/scattergories-host-login-resolver';
import { ScattergoriesComponent } from './scattergories/scattergories.component';
import { PageHomeRouterComponent } from './page-home-router/page-home-router.component';

const routes: Routes = [
  {
    path: '',
    component: PageHomeRouterComponent
  },
  {
    path: 'home',
    component: PageHomeComponent
  },
  {
    path: 'login',
    component: PageLoginComponent
  },
  {
    path: 'trivia',
    component: TriviaComponent,
    resolve: {
      gameExists: TriviaHostLoginResolver
    }
  },
  {
    path: 'telesketchpad',
    component: TelestrationsComponent,
    resolve: {
      gameExists: TelestrationsHostLoginResolver
    }
  },
  {
    path: 'liars-dice',
    component: LiarsDiceComponent,
    resolve: {
      gameExists: LiarsDiceHostLoginResolver
    }
  },
  {
    path: 'scattergories',
    component: ScattergoriesComponent,
    resolve: {
      gameExists: ScattergoriesHostLoginResolver
    }
  },
  {
    path: 'host/liars-dice',
    component: PageLiarsDiceHostComponent,
    resolve: {
      gameExists: LiarsDiceHostLoginResolver
    }
  },
  {
    path: 'host/telesketchpad',
    component: PageTelestrationsHostComponent,
    resolve: {
      gameExists: TelestrationsHostLoginResolver
    }
  },
  {
    path: 'host/trivia',
    component: PageTriviaHostComponent,
    resolve: {
      gameExists: TriviaHostLoginResolver
    }
  },
  {
    path: 'host/scattergories',
    component: PageScattergoriesHostComponent,
    resolve: {
      gameExists: ScattergoriesHostLoginResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
